<template>
  <div class="global-home">
    <div class="global-header">
      <div @click="toIndex" class="global-header-logo"></div>
      <div class="global-header-line"></div>
      <div>
        <Time />
      </div>
      <div
        v-if="$route.name != 'DeviceSet'"
        class="global-header-run-msg0"
        @click="toNet"
      >
        <img
          v-if="$store.state.netReachable"
          :src="require('./img/wifi.png')"
        />
        <img v-else :src="require('./img/wifi_no.png')" />
        <span class="gray" v-if="$store.state.netReachable === undefined"
          >--</span
        >
        <span v-else-if="$store.state.netReachable">已联网</span>
        <span class="gray" v-else>未联网</span>
      </div>
      <div
        @click="tiaoshi"
        v-if="$route.name != 'DeviceSet'"
        :class="
          'global-header-run-msg' +
          (run == 1 ? ' global-header-run-msg-run' : '')
        "
      >
        {{ runStr }}
      </div>
      <div
        v-if="$route.name != 'DeviceSet'"
        class="global-header-class-msg"
        @click="toAdminSet"
      >
        {{ classStrNew }}
      </div>
      <div class="global-header-btns">
        <!-- <router-link
          class="global-header-btn"
          :to="{ name: 'History' }"
          v-if="this.$route.name == 'Index'"
          >历史</router-link
        > -->
        <!-- <Keyboard
          ref="passwordKeyboard"
          :isPassword="true"
          :isCustom="true"
          msg="请输入密码"
          @ok="passwordOk"
        > -->
        <router-link
          v-if="$route.name != 'DeviceSet'"
          class="global-header-btn setting"
          :to="{ name: 'userSetIndex' }"
        >
          <img :src="require('./img/setting.png')" />
          设置
        </router-link>
        <!-- </Keyboard> -->
        <!-- <div
          @click="back"
          v-if="$route.name == 'ResultChart' || $route.name == 'ResultData'"
          class="global-header-btn"
          :to="{ name: 'Index' }"
        >
          返回
        </div> -->
      </div>
    </div>
    <div class="global-content">
      <router-view />
    </div>
    <el-dialog title="密码" v-model="dialogVisible" width="50%">
      <el-form ref="form" :model="form" :rules="formRules">
        <el-form-item label="请输入密码" prop="password">
          <Keyboard v-model="form.password" :isPassword="true">
            <el-input v-model="form.password" show-password></el-input>
          </Keyboard>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="submit">确 定</el-button>
        </span>
      </template>
    </el-dialog>

    <el-dialog title="GTMDHYD" v-model="tiaoshiDialog" width="50%">
      <el-form ref="tiaoshiForm" :model="tiaoshiForm">
        <el-form-item label="websocket url" prop="password">
          <el-select v-model="tiaoshiForm.url" placeholder="">
            <el-option
              v-for="item in tiaoshiUrls"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="tiaoshiSubmit">确 定</el-button>
        </span>
      </template>
    </el-dialog>

    <history-modal v-model:visible="historyVisible" />
    <Keyboard
      ref="panKeyboard"
      v-model="secret"
      :isCustom="true"
      msg="请输入密码进入开发者模式"
      @ok="adminOk"
      @escClick="clearTimerAdmin"
    >
    </Keyboard>
  </div>
</template>

<script>
import Time from "@/components/time/index.vue";
import moment from "moment";
import { ElMessage } from "element-plus";
import Keyboard from "@/components/keyboard/index.vue";
import { mapMutations } from "vuex";
import {
  url,
  urlJWEM,
  url69,
  url127,
  url192,
  urlYun,
  setUrl,
} from "../../config/index.js";
let tiaoshiT = -1;
let tiaoshiN = 0;
let adminT = -1;
let adminN = 0;
export default {
  name: "Home",
  components: { Keyboard, Time },
  data() {
    return {
      runStr: "",
      run: "",
      form: {
        password: "",
      },
      dialogVisible: false,
      formRules: {
        password: [{ required: true, message: "必填" }],
      },
      tiaoshiDialog: false,
      tiaoshiForm: {
        url: url127,
      },
      tiaoshiUrls: [
        { label: "云地址", value: urlYun },
        { label: "望都", value: url69 },
        { label: "君威二牧", value: urlJWEM },
        { label: "127", value: url127 },
        { label: "192", value: url192 },
      ],
      secret: "",
    };
  },
  methods: {
    ...mapMutations["setTick"],
    toIndex() {
      if (this.$route.name != "DeviceSet") {
        this.$router.push({ name: "Index" });
      }
    },
    toNet() {
      this.$router.push({
        name: "userSetSystemHome",
        query: { active: "adminSetSystemNet" },
      });
    },
    tiaoshiSubmit() {
      setUrl(this.tiaoshiForm.url);
      this.tiaoshiDialog = false;
      this.$root.reload();
    },
    tiaoshi() {
      tiaoshiN++;
      clearTimeout(tiaoshiT);
      tiaoshiT = setTimeout(() => {
        tiaoshiN = 0;
      }, 500);

      if (tiaoshiN == 5) {
        tiaoshiN = 0;
        clearTimeout(tiaoshiT);
        this.$router.push({ name: "tiaoZhuan" });
      }
    },
    //  点击5下进入管理员页面
    toAdminSet() {
      adminN++;
      clearTimeout(adminT);
      adminT = setTimeout(() => {
        adminN = 0;
      }, 500);

      if (adminN == 5) {
        this.$refs.panKeyboard.show();
        this.clearTimerAdmin();
      }
    },
    async adminOk(s) {
      const date = new Date();
      if (s !== "" && s == date.getMinutes()) {
        await this.$store.commit("setTick");
        this.$router.push("/adminSet/index");
      }
      this.$refs.panKeyboard.hide();
      this.secret = "";
      clearInterval(this.timer);
      this.clickNumber = 0;
    },
    clearTimerAdmin() {
      clearInterval(adminT);
      adminN = 0;
    },
    passwordOk(s) {
      // console.log("passwordOk");
      // console.log(s);
      // console.log(this.$refs);
      // console.log(this.$refs.passwordKeyboard);

      if (s == "0322") {
        this.$refs.passwordKeyboard.isShow = false;
        // this.$router.push({ name: "AutoSet" });
        this.$router.push({ name: "SetHome" });
      } else {
        ElMessage("密码错误");
      }
    },

    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.form.password == "0322") {
            this.form.password = "";
            this.dialogVisible = false;
            // this.$router.push({ name: "AutoSet" });
            this.$router.push({ name: "SetHome" });
          } else {
            ElMessage("密码错误");
          }
        } else {
          return false;
        }
      });
    },
    goSet() {
      this.form.password = "";
      this.dialogVisible = true;
      if (this.$refs.form) {
        this.$refs.form.resetFields();
      }
    },
    back() {
      this.$router.back();
    },
    checkTimeInClass(now, checkClass) {
      // console.log("checkTimeInClass");
      // console.log("now");
      // console.log(now);
      // console.log("checkClass");
      // console.log(checkClass);
      // console.log("time0");
      // console.log(moment(moment().format("YYYY-MM-DD") + " 00:00:00").toDate());
      // console.log("time24");
      // console.log(moment(moment().format("YYYY-MM-DD") + " 24:00:00").toDate());
      // debugger;
      let time0 = moment(moment().format("YYYY-MM-DD") + " 00:00:00")
        .toDate()
        .getTime();
      let time24 = moment(moment().format("YYYY-MM-DD") + " 24:00:00")
        .toDate()
        .getTime();
      let nowT = now.getTime();
      let st = checkClass[0].getTime();
      let et = checkClass[1].getTime();
      if (st < et) {
        if (nowT >= st && nowT <= et) {
          return true;
        } else {
          return false;
        }
      } else {
        if ((nowT >= st && nowT <= time24) || (nowT >= time0 && nowT <= et)) {
          return true;
        } else {
          return false;
        }
      }
    },
  },
  computed: {
    myClasses() {
      let classes = JSON.parse(JSON.stringify(this.$store.state.classes));
      classes.forEach((v, k) => {
        v.st = moment().format("YYYY-MM-DD") + " " + v.st;
        v.et = moment().format("YYYY-MM-DD") + " " + v.et;
      });
      return classes;
    },
    myClassesNew() {
      let classes = JSON.parse(JSON.stringify(this.$store.state.classes));
      let newClasses = [];
      classes.forEach((v, k) => {
        newClasses.push([
          moment(moment().format("YYYY-MM-DD") + " " + v.st).toDate(),
          moment(moment().format("YYYY-MM-DD") + " " + v.et).toDate(),
        ]);
      });
      return newClasses;
    },
    classStrNew() {
      let run = 0;
      let now = moment().toDate();
      let str = "";
      this.myClassesNew.forEach((v, k) => {
        // console.log("now");
        // console.log(now);
        // console.log("check");
        // console.log(v);
        // console.log("check result");
        // console.log(this.checkTimeInClass(now, v));
        if (this.checkTimeInClass(now, v)) {
          str = `班次${k + 1}脉动监测进行中`;
          run = 1;
        } else if (
          this.checkTimeInClass(now, [
            v[1],
            this.myClassesNew[(k + 1) % this.myClassesNew.length][0],
          ])
        ) {
          let nowTime = now.getTime();
          let toTime =
            this.myClassesNew[(k + 1) % this.myClassesNew.length][0].getTime();
          let diffTime;
          if (nowTime <= toTime) {
            diffTime = toTime - nowTime;
          } else {
            let time0 = moment(moment().format("YYYY-MM-DD") + " 00:00:00")
              .toDate()
              .getTime();
            let time24 = moment(moment().format("YYYY-MM-DD") + " 24:00:00")
              .toDate()
              .getTime();
            diffTime = time24 - nowTime + (toTime - time0);
          }
          let str1H = Math.floor(diffTime / (60 * 60 * 1000));
          let str1M = Math.floor((diffTime % (60 * 60 * 1000)) / (60 * 1000));
          let str1 = `${str1H != 0 ? str1H + "小时" : ""}${
            str1M < 1 ? "1分" : str1M + "分"
          }后开始`;
          // str = `已完成${k + 1}个班次的监测，下一次监测将于${str1}`;
          str = `下一次监测将于${str1}`;
        }
      });
      if (run) {
        this.runStr = "监测运行中";
        this.run = 1;
      } else {
        this.runStr = "监测已就绪";
        this.run = 0;
      }
      return str;
    },
    classStr() {
      let run = 0;
      // console.log("classStr");
      // console.log(this.$store.state.classes);
      // console.log(moment().format("YYYY-MM-DD"));

      // console.log(this.myClasses);
      let now = moment();
      // now = moment("2021-07-11 9:28:12");
      // now = moment("2021-07-11 10:00:00");
      // now = moment("2021-07-11 11:27:00");
      // now = moment("2021-07-11 15:15:00");
      // now = moment("2021-07-11 17:00:00");
      let diffFirst = now.diff(moment(this.myClasses[0].st));
      let diffLast = now.diff(
        moment(this.myClasses[this.myClasses.length - 1].et)
      );
      // console.log(diffFirst);
      let str = "";
      if (diffFirst < 0) {
        diffFirst = -diffFirst;
        let duration = moment.duration(diffFirst);
        let strH = moment({
          h: duration.hours(),
          m: duration.minutes(),
          s: duration.seconds(),
        }).format("H");
        let strM = moment({
          h: duration.hours(),
          m: duration.minutes(),
          s: duration.seconds(),
        }).format("m");
        str = `今日脉动监测将于${parseFloat(strH) != 0 ? strH + "小时" : ""}${
          parseFloat(strM) < 1 ? "1分" : strM + "分"
        }后开始`;

        // console.log(str);
      } else if (diffLast > 0) {
        str = "今日脉动监测已结束";
      } else {
        this.myClasses.forEach((v, k) => {
          let diffSt = now.diff(moment(v.st));
          let diffEt = now.diff(moment(v.et));
          let diffNextSt;
          if (this.myClasses[k + 1]) {
            diffNextSt = now.diff(moment(this.myClasses[k + 1].st));
          }
          if (diffSt >= 0 && diffEt <= 0) {
            str = `班次${k + 1}脉动监测进行中`;
            run = 1;
          } else if (diffNextSt && diffEt > 0 && diffNextSt < 0) {
            diffNextSt = -diffNextSt;
            let duration = moment.duration(diffNextSt);
            let str1H = moment({
              h: duration.hours(),
              m: duration.minutes(),
              s: duration.seconds(),
            }).format("H");
            let str1M = moment({
              h: duration.hours(),
              m: duration.minutes(),
              s: duration.seconds(),
            }).format("m");
            let str1 = `${parseFloat(str1H) != 0 ? str1H + "小时" : ""}${
              parseFloat(str1M) < 1 ? "1分" : str1M + "分"
            }后开始`;
            str = `已完成${k + 1}个班次的监测，下一次监测将于${str1}`;
          }
        });
      }
      if (run) {
        this.runStr = "监测运行中";
        this.run = 1;
      } else {
        this.runStr = "监测已就绪";
        this.run = 0;
      }
      return str;
    },
  },
  mounted() {
    // console.log("home mounted");
    // console.log(this.$route);
    // console.log(this.$root);
  },
};
</script>
<style lang="less" src="./index.less"></style>
